// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Oe_E","footer":"styles_footer__-a9fB","passCodeTooltip":"styles_passCodeTooltip__2N0-Q"};